var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.iconType)?_c('div',{staticClass:"icon",style:({
      '-webkit-mask-image':`url(${_vm.icon})`,
     ..._vm.iconStyle
  })}):_c('i',{class:[_vm.iconClass,_vm.icon]})
}
var staticRenderFns = []

export { render, staticRenderFns }